<template>
    <v-dialog-old @hidden="cancel" :onCloseEsc="closeModal" ref="searchDialog" :special-styles="{ width: '700px' }">
        <ResultDialog ref="resultDialog"/>

        <fieldset>
            <legend>Поиск по фидам врачей для Яндекса</legend>

            <form>
                <input v-model="text" placeholder="Поиск с учетом регистра"/>

                <v-loading-component @click="search" style="margin: auto; width: max-content; display: block;">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['green', loadingClass]"
                                :disabled="disableBtn"
                                style="padding: 6px 10px;">
                            Найти
                        </button>
                    </template>
                </v-loading-component>
            </form>
        </fieldset>
    </v-dialog-old>
</template>

<script>
import ResultDialog from "./ResultDialog";

    export default {
        components: {
            ResultDialog
        },
        data: () => ({
            text: '',
            disableBtn: false,
        }),
        methods: {
            show() {
                this.$refs.searchDialog.show();
            },
            cancel() {
                this.text = '';
                this.disableBtn = false;
            },
            closeModal() {
                this.cancel();
                this.$refs.searchDialog.hide();
            },
            async search(btn) {
                this.disableBtn = true;
                btn.startLoadingAnimation();

                await this.axios.post('/admin/settings/tools/searchInDoctorFeeds', {text: this.text})
                    .then((response) => {
                        this.disableBtn = false;
                        btn.stopLoadingAnimation();

                        this.$refs.resultDialog.show(response.data);
                    }).catch((error) => {
                        this.disableBtn = false;
                        btn.stopLoadingAnimation();
                    })
            },
        },
    }
</script>
